// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RecruitmentTile_wrapper__1Kxzt","container":"RecruitmentTile_container__2nE4Z","header":"RecruitmentTile_header__3xhB-"};